export default {
  //订单状态枚举
  ORDER_STATUS_ENUM: [
    {
      label: "全部",
      value: null
    },
    {
      label: "未知异常",
      value: -1
    },
    {
      label: "初始下单",
      value: 0
    },
    {
      label: "已经支付",
      value: 10
    },
    {
      label: "订单取消",
      value: 20
    },
    {
      label: "申请退款",
      value: 30
    },
    {
      label: "申请退款通过",
      value: 40
    },
    {
      label: "申请被驳回",
      value: 50
    },
    {
      label: "退款成功",
      value: 60
    },
    {
      label: "退款异常",
      value: 70
    }
  ],
  //支付状态枚举
  PAID_STATUS_ENUM: [
    {
      label: "全部",
      value: null
    },
    {
      label: "已支付",
      value: true
    },
    {
      label: "未支付",
      value: false
    }
  ],
  //机器类型
  MACHINE_TYPE_ENUM: [
    {
      label: "全部",
      value: ""
    },
    {
      label: "上翻盖洗衣机",
      value: 1
    },
    {
      label: "前置翻盖洗衣机",
      value: 2
    },
    {
      label: "烘干机",
      value: 9
    }
  ],
  //机器状态枚举
  MACHINE_STATUS_ENUM: [
    {
      label: "全部",
      value: ""
    },
    {
      label: "离线",
      value: -1
    },
    {
      label: "门未关",
      value: 0
    },
    {
      label: "待机状态",
      value: 2
    },
    {
      label: "启动状态",
      value: 8
    },
    {
      label: "运行状态",
      value: 16
    },
    {
      label: "运行结束",
      value: 32
    },
    {
      label: "机器故障",
      value: 64
    },
    {
      label: "菜单模式",
      value: 128
    },

    {
      label: "进水超时",
      value: 1006
    },
    {
      label: "排水超时",
      value: 1007
    },
    {
      label: "脱水撞桶", //脱水时撞桶
      value: 1008
    },
    {
      label: "脱水开盖",
      value: 1009
    },
    {
      label: "水位异常", //水位传感器异常
      value: 1010
    },
    {
      label: "溢水报警",
      value: 1011
    },
    {
      label: "电机故障",
      value: 1012
    }
  ],
  //产品类型
  PRODUCT_TYPE_ENUM: [
    {
      label: "全部",
      value: ""
    },
    {
      label: "洗衣",
      value: "Wash"
    },
    {
      label: "烘干",
      value: "Dry"
    },
    {
      label: "加液",
      value: "AddLiquid"
    },
    {
      label: "优惠券",
      value: "Coupon"
    },
    {
      label: "VIP卡",
      value: "VIP"
    },
    {
      label: "店铺限时优惠",
      value: "AutoPromotion"
    }
  ],
  //支付方式
  PAY_TYPE_ENUM: [
    {
      label: "全部",
      value: ""
    },
    {
      label: "微信",
      value: "1"
    },
    {
      label: "支付宝",
      value: "2"
    },
    {
      label: "收钱吧",
      value: "3"
    }
  ],
  //业务类型枚举
  BUSSINESS_TYPE_ENUM: [
    {
      label: "增加机器",
      value: "101"
    },
    {
      label: "更新机器",
      value: "102"
    },
    {
      label: "删除机器",
      value: "103"
    },
    {
      label: "操作机器",
      value: "104"
    },
    {
      label: "增加产品",
      value: "201"
    },
    {
      label: "更新产品",
      value: "202"
    },
    {
      label: "删除产品",
      value: "203"
    },
    {
      label: "禁用产品",
      value: "204"
    },
    {
      label: "增加门店",
      value: "301"
    },
    {
      label: "更新门店",
      value: "302"
    },
    {
      label: "删除门店",
      value: "303"
    },

    {
      label: "微信统一订单接口",
      value: "401"
    },
    {
      label: "微信支付订单查询",
      value: "402"
    },
    {
      label: "微信支付订单关闭",
      value: "403"
    },
    {
      label: "微信支付申请退款",
      value: "404"
    },
    {
      label: "下载微信账单",
      value: "405"
    },
    {
      label: "用户支付成功",
      value: "410"
    },

    {
      label: "新增优惠券",
      value: "501"
    },
    {
      label: "删除优惠券",
      value: "502"
    },
    {
      label: "修改优惠券",
      value: "503"
    },
    {
      label: "新增VIP卡",
      value: "504"
    },
    {
      label: "删除VIP卡",
      value: "505"
    },
    {
      label: "更新VIP卡",
      value: "506"
    },

    {
      label: "提现申请",
      value: "601"
    },

    {
      label: "新增产品模板",
      value: "701"
    },

    {
      label: "修改产品模板",
      value: "702"
    },

    {
      label: "删除产品模板",
      value: "703"
    },

    {
      label: "加液器新增",
      value: "901"
    },

    {
      label: "加液器更新",
      value: "902"
    },

    {
      label: "加液器删除",
      value: "903"
    },

    {
      label: "自动Job",
      value: "9901"
    }
  ],
  //退款状态枚举
  REFUND_STATUS_ENUM: [
    {
      label: "全部",
      value: ""
    },
    {
      label: "等待审核",
      value: "0"
    },
    {
      label: "申请通过",
      value: "10"
    },
    {
      label: "申请拒绝",
      value: "20"
    },
    {
      label: "已打款",
      value: "30"
    },
    {
      label: "打款异常",
      value: "40"
    },
    {
      label: "撤销申请",
      value: "50"
    }
  ],

  RECEIPT_STATUS_ENUM: [
    {
      label: "提交审核",
      value: "0"
    },
    {
      label: "审核通过",
      value: "1"
    },
    {
      label: "拒绝开票",
      value: "2"
    }
  ],

  //城市枚举
  CITY_ENUM: [
    {
      label: "全部",
      value: ""
    },
    {
      label: "上海",
      value: "上海"
    },
    {
      label: "北京",
      value: "北京"
    },
    {
      label: "杭州",
      value: "杭州"
    },
    {
      label: "苏州",
      value: "苏州"
    },
    {
      label: "宁波",
      value: "宁波"
    },
    {
      label: "无锡",
      value: "无锡"
    },
    {
      label: "东莞",
      value: "东莞"
    },
    {
      label: "其他",
      value: "其他"
    }
  ],

  PASSWORD: [
    "%grz4$942#!y",
    "DkHuU*J5HVn@",
    "vv*TjiLSUWJ^",
    "HTZ4njWa7kPS",
    "mXcYyxoeVD&5",
    "$gWYthl@S%SY",
    "nWcJ1yQZhQIk",
    "UM4Foa8Xrzqq"
  ]
};
